export const baseUrl = "https://back-fit.ibdaa-booking.com/api";

export const loginURL = "login";

export const clientsURL = "clients/";

export const trainersURL = "trainers";

export const clientURL = "clients";

export const usersURL = "users";

export const permissionsURL = "permissions";

export const notificationsURL = "notifications";

export const statisticsURL = "statistics";

export const departmentsURL = "departments";

export const contactUsURL = "contact-us";
